export const adjustDescriptions = ( layout ) => {
	const layoutSvg = layout.querySelector( 'svg' );

	if ( !layoutSvg )
	{
		return;
	}

	const layoutRect = layoutSvg.getBoundingClientRect();
	const centerTop = layoutRect.top + layoutRect.height / 2;
	const centerLeft = layoutRect.left + layoutRect.width / 2;

	Array.from( layout.querySelectorAll( 'li[data-for]' ) ).forEach( ( it ) => {
		const point = layout.querySelector( `#DESC-${it.dataset.for}` );

		if ( !point )
		{
			it.remove();
			
			return;
		}

		const pointRect = layout.querySelector( `#DESC-${it.dataset.for}` ).getBoundingClientRect();

		if ( pointRect.top > centerTop )
		{
			it.classList.add( 'bottom' );
		}
		else
		{
			it.classList.add( 'top' );
		}

		if ( pointRect.left > centerLeft )
		{
			it.classList.add( 'right' );
		}
		else
		{
			it.classList.add( 'left' );
		}

		it.style.top = ( pointRect.top - layoutRect.top ) * 100 / layoutRect.height + '%';
		it.style.left = ( pointRect.left - layoutRect.left ) * 100 / layoutRect.width + '%';
	} );
};
